<template>
  <v-main>
    <v-container fluid>
      <v-row justify="start">
        <div class="hello">
          <h1>Служебные данные</h1>
          <ul>
            <li>
              Версия: {{ versions }}
            </li>
          </ul>
        </div>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import axios from 'axios'
import {authHeader} from '../_helpers'

export default {
  name: 'InternalComponents',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      versions: null
    }
  },
   asyncComputed: {
      reports: {
        get () {
          this.loading = true
          this.asyncLoading = true
          let vm = this
          const requestOptions = {
            headers: authHeader()
          }
          //console.log(this.$store.state.tableData.backend)
          axios(this.$store.state.tableData.backend + '/version', requestOptions).then((response) => {
            //console.log(response)
          vm.versions = response.data
          return response.data
          // this.$router.push(this.$route.query.redirect || '/')
        }).catch((error) => {
          throw new Error(`You can't load the data`)
        })
          // return  vm.getReports()
        },
        default: []
      }
    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/internalComponents.vue